import { Injectable } from '@angular/core';
import * as urlLib from 'url';
import { environment } from '../../environments/environment';
import { AmplifyService } from './amplify.service';

@Injectable({
  providedIn: 'root',
})
export class SignService {
  constructor(private readonly amplifyService: AmplifyService) {}

  // sign a request using Amplify Auth and Signer
  public async signRequest(url: string, method: string, data: unknown): Promise<any> {
    // the following code is adapted from AWS Amplify Rest Client
    const { ...parsedUrl } = urlLib.parse(url, true, true);

    const formattedUrl = urlLib.format({
      ...parsedUrl,
      query: { ...parsedUrl.query },
    });

    const credential = await this.amplifyService.getCurrentCredentials();

    const params = {
      headers: {},
      data: data,
      method: method,
      url: formattedUrl,
    };

    // cred object keys should stay the same so that
    // Signer.sign function can access the keys
    const cred = {
      secret_key: credential.secret_key,
      access_key: credential.access_key,
      session_token: credential.session_token,
    };

    // set your region and service here
    const serviceInfo = {
      region: environment.AWS_REGION,
      service: environment.API_SERVICE,
    };

    // Signer.sign takes care of all other steps of Signature V4
    const signedReq = await this.amplifyService.getSignedRequest(params, cred, serviceInfo);

    return Promise.resolve(signedReq);
  }
}
